import { Post } from 'components/Post';

const BlogPost = () => <Post sportCategory="mlb" />;
export default BlogPost;
